function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.314 2c.552 0 1 .448 1 1v3.536c0 .265-.106.52-.293.707L7.243 14.02c-.39.39-1.024.39-1.415 0l-3.535-3.536c-.39-.39-.39-1.023 0-1.414L9.07 2.293C9.26 2.105 9.513 2 9.778 2h3.536zm-1.475 2.475c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414.39.39 1.023.39 1.414 0 .39-.39.39-1.024 0-1.414z"
});

var SvgIconSmallTagFill = function SvgIconSmallTagFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSmallTagFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-small-tag-fill.80cb1dc6.svg";
export { ForwardRef as ReactComponent };